import { parseCookies, setCookie } from 'nookies';

export const useCookies = () => {
  const setLoginCookies = (access_token: string, refresh_token: string) => {
    setCookie(null, 'accessToken', access_token, {
      maxAge: 7 * 24 * 60 * 60, // 7 days
      path: '/',
    });
    setCookie(null, 'refreshToken', refresh_token, {
      maxAge: 30 * 24 * 60 * 60, // 30 days
      path: '/',
    });
  };

  const setEmailCookie = (email: string) => {
    setCookie(null, 'email', email, {
      maxAge: 60 * 3,
      path: '/',
    });
  };

  const getEmailCookie = () => {
    const cookies = parseCookies();
    return cookies.email || null;
  };

  const getAccessToken = () => {
    const cookies = parseCookies();
    return cookies.accessToken || '';
  };

  return {
    setLoginCookies,
    setEmailCookie,
    getEmailCookie,
    getAccessToken,
  };
};
